import { useHistory } from 'react-router-dom';
import { CandidateStatus } from '../../../../../../domain/PermanentJobs';

export const ActionComponent = ({ row, onHire, onReject }) => {
  const history = useHistory();
  const status = row.officeStatus;

  if (status === CandidateStatus.APPLIED) {
    return (
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          className="btn btn-sm btn-danger"
          style={{ width: 74 }}
          onClick={(e) => {
            e.stopPropagation();
            onReject?.(row);
          }}
        >
          Reject
        </button>
        <button
          type="button"
          className="btn btn-sm btn-info"
          style={{ width: 74 }}
          onClick={(e) => {
            e.stopPropagation();
            history.push(`/job/${row?.onsiteInterviewId}?scrollToTab=true`);
          }}
        >
          Review
        </button>
      </div>
    );
  }

  if (status === CandidateStatus.INTERVIEWED) {
    return (
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          className="btn btn-sm btn-danger"
          style={{ width: 74 }}
          onClick={(e) => {
            e.stopPropagation();
            onReject?.(row);
          }}
        >
          Reject
        </button>
        <button
          type="button"
          className="btn btn-sm btn-info"
          style={{ width: 74 }}
          onClick={(e) => {
            e.stopPropagation();
            onHire?.(row);
          }}
        >
          Hire
        </button>
      </div>
    );
  }

  return null;
};
